export default __webpack_public_path__ + "assets/success-circle-component.1e425e19.svg";